import { render } from "./cp_OnkeySet.vue?vue&type=template&id=5b5f5af0&scoped=true"
import script from "./cp_OnkeySet.vue?vue&type=script&lang=js"
export * from "./cp_OnkeySet.vue?vue&type=script&lang=js"

import "./cp_OnkeySet.vue?vue&type=style&index=0&id=5b5f5af0&scoped=scoped&lang=less"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5f5af0"]])

export default __exports__